var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, "-->\n", /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.46 37.96C178.358 37.96 218.96 78.5615 218.96 128.46C218.96 178.359 178.359 218.96 128.46 218.96C78.5615 218.96 37.96 178.358 37.96 128.46C37.9601 78.5616 78.5616 37.9601 128.46 37.96ZM70.7298 191.836C85.0783 204.919 103.865 213.206 124.53 214.144L102.223 191.836H70.7298ZM132.397 214.144C153.06 213.205 171.843 204.917 186.19 191.836H154.711L132.397 214.144ZM128.467 210.377L147.008 191.836H109.926L128.467 210.377ZM160.159 186.389H186.389V160.159L160.159 186.389ZM70.5383 104.471V152.449L104.478 186.389H152.456L186.389 152.456V104.464L152.463 70.5383H104.471L70.5383 104.471ZM70.5383 186.389H96.7754L70.5383 160.152V186.389ZM42.769 132.382C43.7047 153.053 52.0049 171.839 65.0908 186.19V154.704L42.769 132.382ZM191.836 154.711V186.183C204.914 171.838 213.203 153.062 214.144 132.404L191.836 154.711ZM191.836 147.008L210.384 128.46L191.836 109.912V147.008ZM46.5496 128.46L65.0908 147.001V109.919L46.5496 128.46ZM65.0908 70.7227C52.0043 85.0722 43.7065 103.861 42.769 124.53L65.0908 102.216V70.7227ZM191.836 102.202L214.144 124.509C213.202 103.852 204.914 85.0734 191.836 70.7298V102.202ZM70.5383 96.7683L96.7683 70.5383H70.5383V96.7683ZM186.389 96.7541V70.5383H160.166L186.389 96.7541ZM154.718 65.0908H186.197C171.849 52.0058 153.063 43.7079 132.397 42.769L154.718 65.0908ZM109.919 65.0908H147.015L128.467 46.5425L109.919 65.0908ZM124.53 42.769C103.861 43.7065 85.0722 52.0043 70.7227 65.0908H102.216L124.53 42.769Z",
    fill: "#4B4B4B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRound);
export default __webpack_public_path__ + "static/media/Round.309ffb7b39991b93fac1b0bd639c3bfe.svg";
export { ForwardRef as ReactComponent };